// Force-Build: 1
import appStarterFactory from 'bundles/page/lib/appStarterFactory';
import appEnv from 'bundles/promotions/appEnv';

export default appStarterFactory(appEnv);
